import app from 'firebase/app';
import 'firebase/database';

const config = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: "https://harmonize-38fca.firebaseio.com",
    projectId: process.env.FIREBASE_PROJECT_ID, 
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSENGER,
    appId: process.env.FIREBASE_APP_ID
};
 
class Firebase {
  constructor() {
      console.log('firebase init')

    app.initializeApp(config);

    this.db = app.database();
  }

  addPoll (poll) {
    return this.db.ref('/polls').push(poll);
  }

  getPollById(id) {
      return this.db.ref('/polls/' + id).once('value');
  }

  addAnswerPoll(key) {
    return this.db.ref('/answer').push({ parentForm: key })
      .then(response => {
        return this.db.ref('/polls/' + key).update({ answerForm: response.key})
      })
  }
}

const singleton = new Firebase();
export default singleton